import React from "react";
import { IRecorderContext } from "../types/context";

export const RecorderContext = React.createContext<IRecorderContext>(null);
